module.exports = __webpack_public_path__ + "assets/img/de68f7b608aa5bfcbb31d2f86ef728f7.png";